import React from 'react'

import HintPopover from "../../../../../core/gd-ui/hint-popover/hint-popover"

export default function PortfolioAccessQuickLink(props:any) {

    const onClick = () => {
        gd.goTo('portfolio/{0}/info/access'.f(props.projectCollectionId))
        // gd.modals.portfolio.editSettings(props.projectCollectionId)
    }

    const projectCollection = gd.session.projectCollections.get(props.projectCollectionId)
    if (!projectCollection || !projectCollection.isEditorAccessUser) return null

    const isPrivate = !projectCollection.users || _.size(projectCollection.users)<2

    if (isPrivate) {
        return (
            <div className={Classes("ui5-ico-lock", props.className)} onClick={onClick}>
                <HintPopover hint="Private"/>
            </div>
        )
    }

    return (
        <div className={Classes("ui5-sharing", props.className)} onClick={onClick}>
            <div className="i5-users"/>
            <span className="total">{projectCollection.users.length}</span>
            <HintPopover hint="Access"/>
        </div>
    )
}